import { defineFcm } from '../shared/factory';

export const FCM_MEMBERSHIP_PPMU_OFFSITE_LINK = defineFcm('membership_ppmu_offsite_link')
	.asString()
	.withDefault(undefined)
	.toConfig();
